import { render } from "./sideMenu.vue?vue&type=template&id=0206df62&scoped=true"
import script from "./sideMenu.vue?vue&type=script&lang=js"
export * from "./sideMenu.vue?vue&type=script&lang=js"

import "./sideMenu.vue?vue&type=style&index=0&id=0206df62&lang=less&scoped=true"
import "./sideMenu.vue?vue&type=style&index=1&id=0206df62&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0206df62"]])

export default __exports__